/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { UserState } from "src/app/state/user-state";
import { TASK_BAR_MENU_ITEMS } from "src/app/core/constants/menuItems";
import { isNavigationDisabled } from "src/app/state/reducer/buttons.reducer";
import { Router } from "@angular/router";
import { HeaderService } from "src/app/core/services/header.service";

@Component({
  selector: "app-task-bar",
  templateUrl: "./task-bar.component.html",
  styleUrls: ["./task-bar.component.scss"]
})

export class TaskBarComponent {
  protected taskBarMenuItems = TASK_BAR_MENU_ITEMS;
  protected $isNavigationDisabled = this.store.pipe(select(isNavigationDisabled));

  constructor(private router: Router,
    private store: Store<UserState>,
    private headerService: HeaderService) {
  }

  isButtonSelected(buttonName: string): string {
    var url = this.headerService.decodeUrl(this.router.url);
    if (buttonName == "početna" && (url.includes("betting-zadaci") || url.includes("max-cafe") 
      || url.includes("jackpot"))) {
      return "selected";
    }
    return url.includes(buttonName) ? "selected" : "not-selected";
  }
}